import {svgIconWrapper} from '../svg-icon-wrapper';

import LocationPinSolid from './location-pin-solid-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;
    const resolvedColor = validProps.color || validProps.fill || 'black';
    validProps.style = {
        color: resolvedColor,
        ...(validProps.style || {}),
    };

    return <LocationPinSolid {...validProps} />;
}
SvgComponent.iconName = 'locationPinSolid';

export const LocationPinSolidIcon = svgIconWrapper(SvgComponent);
